var exports = {
  "K": "xfb577c5e--7bbd34--icon",
  "N": "xfb577c5e--7bbd34--icon--opened",
};

module.exports = exports;
